import request from '../../untils/request';

export function selectList(data) {
  return request({
    url: '/lessee/selectList',
    method: 'get',
    params: data,
  });
}
export function detail(data) {
  return request({
    url: '/lessee',
    method: 'get',
    params: { id: data },
  });
}

export function saveEdit(data) {
  return request({
    url: '/lessee',
    method: 'post',
    data: data,
  });
}
// 更改小程序联系人信息
export function updateMiniProgramContactInfo(data) {
  return request({
    url: '/lessee/updateMiniProgramContactInfo',
    method: 'post',
    data: data,
  });
}
// PC端商户小程序管理员修改记录列表查询;
export function selectListByLesseeIdPc(data) {
  return request({
    url: '/lesseeAdminModifyRecord/selectListByLesseeIdPc',
    method: 'get',
    params: data,
  });
}
// 添加黑名单
export function blackList(data) {
  return request({
    url: '/blackList',
    method: 'post',
    data: data,
  });
}
